import { hasMany, attr } from '@ember-data/model';
import ShModel from './sh-model';

const FreelancerSearchResultCollection = ShModel.extend({
  // attributes
  totalCount: attr('number'),

  // relationships
  filteredResults: hasMany('freelancerSearchResult', {
    async: false,
    inverse: 'failedResult',
  }),
  results: hasMany('freelancerSearchResult', {
    async: false,
    inverse: 'result',
  })
});

export default FreelancerSearchResultCollection;
